import _ from 'lodash';
import LotsService from "../LotsService";
import {CONTINUOUS_ACTION_LOT_EXPAND, LOTS_TABLE_NAME, SOURCE_LIVE_BIDS, SOURCE_LOTS_TABLE} from "../../constants";
import LotSearch from "../models/LotSearch.model";
import i18n from "../../../shared/i18n";
import {store} from './../../../plugins/vuex/index'

let getDefaultTableData = (differentFields = []) => {
  return {
    loading: false,
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
      total: 0,
    },
    ordering: '-lot_no',
    search: '',
    searchModel: new LotSearch(),
    sale: {},
    extraFilters: {},
    extraExpands: '',
    expand: 'inventory.category,inventory.department,inventory.item_location,inventory.customer.billing_address,auction,inventory.source_inventories_count,inventory.specialists',
    toggleColumns: {
      fields: [...getDefaultFields(), ...differentFields],
      requiredFields: ['stock_no'],
      defaultFields: [
        'sale_no',
        'image',
        'stock_no',
        'lot_no',
        'title',
        'reserve',
        'winning_bidder',
        'negotiation_status',
        'status',
        'customer',
        'account_managers'
      ],
      dynamicFields: [],
    }
  }
};

let getDefaultFields = () => {
  return [
    {
      key: "image",
      label: i18n.t('Image'),
      sortable: false,
      tdClass: 'thumbnail-img-holder',
      isVisible: true,
      expand: 'inventory.images',
      exclude_from_export: true
    },
    {
      key: "stock_no",
      label: i18n.t('Stock'),
      sortable: true,
      tdClass: 'stock-no-col',
      isVisible: true,
      expand: 'inventory.receipt'
    },
    {
      key: "sale_no",
      label: i18n.t('Sale'),
      sortable: true,
      tdClass: 'sale-no-col',
      isVisible: true,
      expand: 'auction.auction_images_export'
    },
    {key: "lot_no", label: i18n.t('Lot'), sortable: true, tdClass: 'lot-no-col', isVisible: true, expand: ''},
    {key: "title", label: i18n.t('Title'), sortable: true, tdClass: 'title-col', isVisible: true, expand: ''},
    {
      key: "date",
      label: i18n.t('Start - End Date'),
      sortable: true,
      tdClass: 'dates-col',
      isVisible: false,
      expand: ''
    },
    {key: "reserve", label: i18n.t('Reserve'), sortable: true, tdClass: 'reserve-col', isVisible: true, expand: ''},
    {key: "low", label: i18n.t('Estimate'), sortable: true, tdClass: 'estimate-col', isVisible: false, expand: ''},
    {
      key: "quantity",
      label: i18n.t('Quantity'),
      sortable: true,
      tdClass: 'quantity-col',
      isVisible: false,
      expand: ''
    },
    {
      key: "hammer_price",
      label: i18n.t('Hammer Price'),
      sortable: true,
      tdClass: 'hammer_price_col',
      isVisible: false,
      expand: 'lot'
    },
    {
      key: "hammer_bp_incl_vat",
      label: i18n.t('Hammer & BP (VAT incl.)'),
      sortable: false,
      tdClass: 'hammer_bp_incl_vat-col',
      isVisible: false,
      expand: 'lot.financial_item'
    },
    {
      key: "winning_bidder",
      label: i18n.t('Winning Bidder'),
      sortable: false,
      tdClass: 'winning-bidder-col',
      isVisible: true,
      expand: 'lot.bidder.customer'
    },
    {
      key: "negotiation_status",
      label: i18n.t('Negotiation Status'),
      sortable: true,
      tdClass: 'negotiation-status-col',
      isVisible: true,
      expand: ''
    },
    {key: "status", label: i18n.t('Status'), sortable: true, tdClass: 'status-col', isVisible: true, expand: ''},
    {
      key: "invoice",
      label: i18n.t('Invoice'),
      sortable: true,
      tdClass: 'invoice-col',
      isVisible: false,
      expand: 'lot.financial_item.invoice'
    },
    {
      key: "settlement",
      label: i18n.t('Settlement'),
      sortable: true,
      tdClass: 'settlement-col',
      isVisible: false,
      expand: 'lot.financial_item.settlement'
    },
    {
      key: "customer",
      label: i18n.t('Vendor'),
      sortable: false,
      tdClass: "customer-col",
      isVisible: true,
      expand: ''
    },
    {
      key: "account_managers",
      label: i18n.t('Account Manager'),
      sortable: false,
      tdClass: "account-managers-col",
      isVisible: true,
      expand: 'inventory.account_managers'
    },
    {
      key: "cataloguing_lifecycle",
      label: i18n.t('Cataloguing Lifecycle'),
      sortable: false,
      tdClass: "cataloguing-lifecycle-col",
      isVisible: false,
      expand: 'inventory'
    },
    {
      key: "photography_lifecycle",
      label: i18n.t('Photography Lifecycle'),
      sortable: false,
      tdClass: "photography-lifecycle-col",
      isVisible: false,
      expand: 'inventory'
    },
    {
      key: "actions",
      label: i18n.t('Actions'),
      sortable: false,
      tdClass: "actions-col",
      isVisible: false,
      expand: 'lot.bidder.customer',
      exclude_from_export: true
    },
    {
      key: 'created_data',
      label: i18n.t('Created at / Created by'),
      sortable: false,
      tdClass: 'created-data-col',
      isVisible: false,
      expand: 'created_by'
    },
    {
      key: 'updated_data',
      label: i18n.t('Updated at / Updated by'),
      sortable: false,
      tdClass: 'updated-data-col',
      isVisible: false,
      expand: 'updated_by'
    },
    {
      key: "recommended_by_user",
      label: i18n.t('Recommended By User'),
      sortable: true,
      isVisible: false,
      tdClass: 'recommended-by-user-col',
      expand: 'inventory.receipt.recommended_by_user'
    },
    {
      key: "total_bids",
      label: i18n.t('Bids'),
      sortable: true,
      isVisible: false,
      tdClass: 'bids-col',
      expand: 'lot.total_bids'
    },
    {
      key: "winner_bid",
      label: i18n.t('Winning Bid'),
      sortable: true,
      isVisible: false,
      tdClass: 'winner-bid-col',
      expand: 'lot.winner_bid'
    },
    {
      key: "highest_bid",
      label: i18n.t('Highest Bid'),
      sortable: true,
      isVisible: false,
      tdClass: 'highest-bid-col',
      expand: 'lot.highest_bid'
    },
    {
      key: "collected",
      label: i18n.t('Collected'),
      sortable: true,
      isVisible: false,
      tdClass: 'collected-col',
      expand: ''
    }, {
      key: "registration_vrm",
      label: i18n.t('Registration (VRM)'),
      sortable: false,
      isVisible: false,
      tdClass: 'registration-vrm-col',
      expand: ''
    }, {
      key: "start_price",
      label: i18n.t('Start Price'),
      sortable: true,
      isVisible: false,
      tdClass: 'start_price-col',
      expand: ''
    },
    {
      key: 'department',
      label: i18n.t('Department'),
      sortable: true,
      tdClass: 'department-col',
      isVisible: false,
      expand: 'inventory.department'
    },
    {
      key: 'category',
      label: i18n.t('Category'),
      sortable: true,
      tdClass: 'category-col',
      isVisible: false,
      expand: 'inventory.category'
    },
    {
      key: 'auction_date_uuid',
      label: i18n.t('Session'),
      sortable: true,
      tdClass: 'auction-date-col',
      isVisible: false,
      expand: 'lot.auction_date'
    },
    {
      key: "reserve_type",
      label: i18n.t('Reserve Type'),
      sortable: true,
      tdClass: 'reserve-type-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'auction_collection_uuid',
      label: i18n.t('Collection'),
      sortable: true,
      tdClass: 'auction-collection-col',
      isVisible: false,
      expand: 'lot.auction_collection'
    },
    {
      key: "specialists",
      label: i18n.t('Specialists'),
      sortable: false,
      tdClass: 'specialists-col',
      isVisible: false,
      expand: 'inventory.specialists'
    },
    {
      key: "sold_via_negotiation",
      label: i18n.t('Sold via Negotiation'),
      sortable: false,
      tdClass: 'sold-via-negotiation-col',
      isVisible: false,
      expand: ''
    },
    {
      key: "condition_requests_count",
      label: i18n.t('Condition Requests Count'),
      sortable: true,
      tdClass: 'condition_request_count-col',
      isVisible: false,
      expand: 'condition_requests_count'
    },
    {
      key: "condition_requests_sent",
      label: i18n.t('Condition Requests Sent'),
      sortable: true,
      tdClass: 'condition_request_sent-col',
      isVisible: false,
      expand: 'condition_requests_sent'
    },
    {
      key: "lot_handling_charge",
      label: i18n.t('Entry Fee'),
      sortable: true,
      tdClass: 'lot_handling_charge-col',
      isVisible: false,
      expand: 'lot.financial_item'
    },
    {
      key: "use_images_for_auction_gallery",
      label: i18n.t("Auction Gallery"),
      isVisible: false,
      sortable: true,
      tdClass: "use_images_for_auction_gallery-col",
      expand: "lot"
    },
    {
      key: "receipt_contract_status",
      label: i18n.t("Consignment Status"),
      isVisible: false,
      sortable: false,
      tdClass: "receipt_contract_status-col",
      expand: "inventory.receipt.receipt_contract_status"
    },
    {
      key: "pre_receipt_contract_status",
      label: i18n.t("Pre-Consignment Status"),
      isVisible: false,
      sortable: false,
      tdClass: "pre_receipt_contract_status-col",
      expand: "inventory.receipt.pre_receipt_contract_status"
    },
    {
      key: "item_location",
      label: i18n.t("Item Location"),
      isVisible: false,
      sortable: true,
      tdClass: "item_location-col",
      expand: "inventory.item_location"
    },
    {
      key: "source_of_sale",
      label: i18n.t("Auction Provider"),
      isVisible: false,
      sortable: true,
      tdClass: "source_of_sale-col",
      expand: "lot"
    },
    {
      key: "dpv_pdf",
      label: i18n.t('DPV PDF'),
      sortable: false,
      isVisible: false,
      exclude_from_export: true,
      expand: 'dpv_pdf'
    },
    {
      key: "proposal_suggestion",
      label: i18n.t('Proposal Suggestion'),
      sortable: true,
      tdClass: 'proposal-suggestion-col',
      isVisible: false,
      expand: ''
    },
    {
      key: "proposal_status",
      label: i18n.t('Proposal Status'),
      sortable: true,
      tdClass: 'proposal-status-col',
      isVisible: false,
      expand: ''
    },
    {
      key: "new_low",
      label: i18n.t('New Low Estimate'),
      sortable: true,
      tdClass: 'new-low-col',
      isVisible: false,
      expand: ''
    },
    {
      key: "new_high",
      label: i18n.t('New High Estimate'),
      sortable: true,
      tdClass: 'new-high-col',
      isVisible: false,
      expand: ''
    },
    {
      key: "new_reserve",
      label: i18n.t('New Reserve'),
      sortable: true,
      tdClass: 'new-reserve-col',
      isVisible: false,
      expand: ''
    },
    {
      key: "new_start_price",
      label: i18n.t('New Start Price'),
      sortable: true,
      tdClass: 'new-reserve-col',
      isVisible: false,
      expand: ''
    },
    {
      key: "proposal_sent_at",
      label: i18n.t('Proposal Sent at'),
      sortable: true,
      tdClass: 'proposal-sent-at-col',
      isVisible: false,
      expand: ''
    },
    {
      key: "proposal_sent_by",
      label: i18n.t('Proposal Sent by'),
      sortable: true,
      tdClass: 'proposal-sent-at-col',
      isVisible: false,
      expand: 'proposal_sent_by'
    },
    {
      key: "proposal_confirmed_at",
      label: i18n.t('Proposal Confirmed at'),
      sortable: true,
      tdClass: 'proposal-confirmed-at-col',
      isVisible: false,
      expand: ''
    },
    {
      key: "proposal_confirmed_by",
      label: i18n.t('Proposal Confirmed by'),
      sortable: true,
      tdClass: 'proposal-confirmed-at-col',
      isVisible: false,
      expand: 'proposal_confirmed_by'
    },
    {
      key: "transfer_info",
      label: i18n.t('Transfer Info'),
      sortable: false,
      tdClass: 'transfer_status-col',
      isVisible: false,
      expand: 'latest_transfer_note_info'
    },
    {
      key: "hide_lot",
      label: i18n.t('Hide Lot'),
      sortable: false,
      tdClass: 'hide_lot-col',
      isVisible: false,
      expand: 'lot'
    },
    {
      key: "tax_status",
      label: i18n.t('Tax Status'),
      sortable: false,
      tdClass: 'tax_status-col',
      isVisible: false,
      expand: 'inventory,lot.financial_item'
    },
    {
      key: 'new_reserve_type',
      label: i18n.t('New Reserve Type'),
      sortable: true,
      tdClass: 'new-reserve-type-col',
      isVisible: false,
      expand: ''
    },
    {
      key: "rep_user",
      label: i18n.t('Representative User'),
      sortable: false,
      tdClass: 'rep-user-col',
      isVisible: false,
      expand: 'inventory.rep_user'
    },
  ]
}

export default {
  namespaced: true,
  state: {
    tableSource: null,
    tableData: {
      sale: getDefaultTableData(),
      inventory: getDefaultTableData(),
      lot: getDefaultTableData(),
      purchasedItems: getDefaultTableData(),
      favoriteLotItems: getDefaultTableData(),
      batchTelephoneBidsGenerationModal: getDefaultTableData(),
    },
    modal: {
      show: false,
      source: null,
      object: null,
      sale: null,
      receipt: null
    },
    reservationModal: {
      show: false,
      source: null,
      object: null,
      sale: null,
      loading: false,
      disableFields: []
    },
    qrLotUpModal: {
      show: false,
      sale: null,
      source: null
    },
    unsoldModal: {
      show: false,
      selectedItems: [],
      isLoading: false,
      error: null
    },
    lotExportImagesTemplateModal: {
      show: false,
      sale: null,
      source: null,
      mode: 'all',
      lot_uuids: null,
      lot_count: 0,
      inventory_uuids: null,
      inventory_count: 0
    },
    negotiationModal: {
      show: false,
      reservation: null,
      bidder: null,
      source: null,
      loading: false
    },
    reserveItemsModal: {
      show: false,
      reservation: null,
      source: null,
      sale: null,
    },
    auctioneerConsole: {
      activeLot: null,
      loading: false,
      sale: null,
    },
    reassignModal: {
      show: false,
      reservations: [],
      source: null,
      loading: false
    },
    bulkAdjustPriceModal: {
      show: false,
      reservations: [],
      source: null,
      increment_calculation_source: null,
      loading: false
    },
    batchSessionUpdateModal: {
      show: false,
      reservations: [],
      source: null,
      sale: null,
      loading: false
    },
    batchFinancialUpdateModal: {
      show: false,
      reservations: [],
      source: null,
      loading: false
    },
    batchCollectionUpdateModal: {
      show: false,
      reservations: [],
      source: null,
      sale: null,
      loading: false
    },
    auctionResultsSyncModal: {
      show: false,
      source: null,
      sale: null,
      loading: false
    },
    lotInfoModal: {
      show: false,
      lot_uuid: null
    }
  },
  actions: {
    resetSearchModel({commit}) {
      commit('resetSearchModel')
    },
    async getModalObject({commit, state, rootState}, {uuid, source}) {
      // todo temporary code, maybe separate cont and non cont code
      const expands = rootState.global.enableContinuousAuction ? CONTINUOUS_ACTION_LOT_EXPAND : '';

      let tmpExpands = [
        'inventory.receipt',
        'inventory.images',
        'inventory.category.dynamic_fields_template',
        'inventory.department',
        'inventory.item_location',
        'inventory.customer.billing_address',
        'inventory.customer.shipping_address',
        'inventory.specialists',
        'lot',
      ]

      if (rootState.global.enableInventoryDraft) {
        tmpExpands.push('inventory.published_at_least_once')
      }

      state.reservationModal.loading = true
      let response = await LotsService.getReservation(uuid, `${tmpExpands.join(',')},${expands}`);

      if (response.success) {
        let r = response.body
        if (r.inventory) {
          r.inventory.specialists_uuids = []
          if (r.inventory.specialists && r.inventory.specialists.length > 0) {
            r.inventory.specialists_uuids = r.inventory.specialists.map(s => s.uuid)
          }
        }
        commit('updateModalObject', {object: _.cloneDeep(r), source})
      } else {
        state.modal.error = response.toastError;
      }
      state.reservationModal.loading = false
    },
    resetTableDataPaginationPage({state}) {
      state.tableData[state.tableSource].pagination.page = 1;
    },
    updateSearchModel({commit, state}, searchModel) {
      commit('updateSearchModel', new LotSearch({
        ...state.tableData[state.tableSource].searchModel,
        ...searchModel
      }));
    },
    updateLotsTablePage({state}, page) {
      state.tableData[state.tableSource].pagination.page = page;
    },
    async getTableParams({state}, payload = null) {
      let data;
      let currentTableData = state.tableData[state.tableSource];
      const ordering = await store.dispatch('global/getTableDataOrdering', {
        tableData: currentTableData,
        tableName: `${LOTS_TABLE_NAME}.${state.tableSource}`
      });

      if (payload) {
        data = {
          ...payload.pagination,
          search: payload.search,
          ordering: payload.ordering,
        };
      } else {
        data = {
          ...currentTableData.pagination,
          search: currentTableData.search,
          ordering: ordering,
        }
      }

      if (currentTableData.searchModel) {
        const searchModelData = currentTableData.searchModel.toJSON();
        data = {
          ...data,
          ...searchModelData
        }
      }

      if (currentTableData.extraFilters) {
        data = {...data, ...currentTableData.extraFilters};
      }

      const expands = state.tableData[state.tableSource].extraExpands;
      const defaultExpand = currentTableData.expand;
      const expand = currentTableData.toggleColumns.fields
        .filter(c => currentTableData.toggleColumns.defaultFields.includes(c.key) && c.expand && !defaultExpand.includes(c.expand))
        .map(c => c.expand)
        .join(',')

      data.expand = [expand, defaultExpand, expands].join(',');

      return data;
    },
    async getTableData({commit, dispatch}, payload) {
      let params = await dispatch('getTableParams', payload);
      commit('updateTableLoading', true);
      const response = await LotsService.getReservations(params);
      commit('updateTableLoading', false);

      if (response.success) {
        const {limit, page, ordering, search} = params
        commit('updateTableData', {
          rows: response.body.results,
          pagination: {limit, page, total: response.body.count},
          ordering,
          search
        });
      }

      return response;
    },
    async resetTable({state, dispatch}) {
      const extraFilters = state.tableData[state.tableSource].extraFilters;
      const sale = state.tableData[state.tableSource].sale;
      const extraExpands = state.tableData[state.tableSource].extraExpands;
      const tmpToggleColumns = _.cloneDeep(state.tableData[state.tableSource].toggleColumns);
      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.tableData[state.tableSource].pagination.limit;
      state.tableData[state.tableSource] = defaultTableData;
      state.tableData[state.tableSource].extraFilters = extraFilters;
      state.tableData[state.tableSource].sale = sale;
      state.tableData[state.tableSource].extraExpands = extraExpands;
      state.tableData[state.tableSource].toggleColumns = tmpToggleColumns;
      dispatch('getTableData');
    },
    async updateTableSource({state}, {extraFilters, source, sale, extraExpands, searchModel}) {
      state.tableSource = source;
      state.tableData[source].extraFilters = extraFilters;
      state.tableData[source].extraExpands = extraExpands;
      if (searchModel) {
        state.tableData[source].searchModel = searchModel;
      }
      state.tableData[source].sale = sale;
    },
    updateModalReceipt({commit}, payload) {
      commit('updateModalReceipt', payload);
    },
    async showModal({commit}, payload) {
      commit('showModal', payload);
    },
    hideModal({commit}) {
      commit('hideModal');
    },
    async createLot({dispatch}, payload) {
      let response = await LotsService.createReservation(payload);

      if (response.success) {
        dispatch('getTableData');
      }

      return response;
    },
    async updateLot({commit, state, rootState, dispatch}, payload) {
      // todo temporary code, maybe separate cont and non cont code
      const expands = rootState.global.enableContinuousAuction ? CONTINUOUS_ACTION_LOT_EXPAND : '';

      let response = await LotsService.updateReservation(payload.uuid, payload,
        `inventory.receipt,inventory.images,inventory.category,inventory.department,inventory.item_location,inventory.specialists,inventory.customer.billing_address,lot.bidder.customer,lot.highest_bid,lot.winner_bid,lot.auction_date,lot.auction_collection,${expands}`);
      if (response.success) {
        if (state.reservationModal.source === SOURCE_LOTS_TABLE) {
          commit('updateLot', response.body);
        } else if (state.reservationModal.source === SOURCE_LIVE_BIDS) {
          dispatch('liveBids/activeLotUpdated', {lot_uuid: response.body.lot.uuid}, {root: true})
        }

      }
      return response;
    },
    async updateListLotImages({commit}, lot) {
      commit('updateLot', lot);
    },
    async withdrawItem({dispatch, state}, reservationUuid) {
      let response = await LotsService.withdrawReservation(reservationUuid);
      if (response.success && state.reservationModal.source === SOURCE_LOTS_TABLE) {
        dispatch('getTableData')
      }
      return response;
    },
    async removeLot({dispatch}, payload) {
      let response = await LotsService.removeReservation(payload.uuid);
      if (response.success) {
        dispatch('getTableData')
      }
      return response;
    },
    async getLot({commit}, {uuid, expand}) {
      commit('updateAuctioneerConsoleLoading', true)
      let res = await LotsService.getLot(uuid, expand);
      commit('updateAuctioneerConsoleLoading', false)
      return res
    },
    async batchRemoveReservations({dispatch}, payload) {
      let response = await LotsService.batchRemoveReservations(payload);
      if (response.success) {
        dispatch('getTableData')
      }
      return response;
    },
    async batchMarkLotsUnsold({dispatch}, payload) {
      let response = await LotsService.batchMarkLotsUnsold(payload);
      if (response.success) {
        dispatch('getTableData')
      }
      return response;
    },
    async showReservationModal({commit}, payload) {
      commit('showReservationModal', payload);
    },
    hideReservationModal({commit}) {
      commit('hideReservationModal');
    },
    showQrLotUpModal({commit}, {source, sale}) {
      commit('showQrLotUpModal', {sale: _.cloneDeep(sale), source});
    },
    hideQrLotUpModal({commit}) {
      commit('hideQrLotUpModal');
    },

    showLotImagesNameModal({commit}, {source, sale, mode, lot_uuids, lot_count, inventory_uuids, inventory_count}) {
      commit('showLotImagesNameModal', {
        sale: _.cloneDeep(sale),
        source,
        mode: mode || 'all',
        lot_uuids: lot_uuids || null,
        lot_count: lot_count || 0,
        inventory_uuids: inventory_uuids || null,
        inventory_count: inventory_count || 0,
      });
    },
    hideLotImagesNameModal({commit}) {
      commit('hideLotImagesName');
    },

    async updateSaleStatus({dispatch}, payload) {
      let response = await LotsService.updateSaleStatus(payload.status, payload.params);
      if (response.success) {
        dispatch('getTableData')
      }
      return response;
    },
    showNegotiationModal({commit}, {reservation = {}, sale, source} = {}) {
      commit('showNegotiationModal', {reservation: _.cloneDeep(reservation), sale: _.cloneDeep(sale), source});
    },
    hideNegotiationModal({commit}) {
      commit('hideNegotiationModal');
    },
    async showReserveItemsModal({commit}) {
      commit('showReserveItemsModal');
    },
    async hideReserveItemsModal({commit}) {
      commit('hideReserveItemsModal');
    },
    async getLotPreviousAndNext(_, uuid) {
      return await LotsService.getLotPreviousAndNext(uuid);
    },
    async getSaleLot({commit}, params) {
      commit('updateAuctioneerConsoleLoading', true)
      const res = await LotsService.getLots(params);

      let templot;
      if (res.success) {
        templot = res.body.results.length ? res.body.results[0] : null
        if (templot) {
          commit('setActiveLot', templot)
          commit('updateAuctioneerConsoleSale', templot.auction)
        }
      }
      commit('updateAuctioneerConsoleLoading', false)
      return templot
    },
    activateLot({commit}, lot) {
      commit('setActiveLot', lot);
    },
    updateAuctioneerConsoleSale({commit}, sale) {
      commit('updateAuctioneerConsoleSale', sale);
    },
    async updateToggleColumns({commit, dispatch}, payload) {
      if (payload.isSaveAction) {
        commit('updateTableLoading', true);
        await commit('updateToggleColumns', payload.selectedColumns);
        await dispatch('getTableData');
        commit('updateTableLoading', false);
      } else {
        await commit('updateToggleColumns', payload.selectedColumns);
      }
    },
    updateNegotiationActiveBidder({state}, payload) {
      state.negotiationModal.bidder = payload;
    },
    showReassignModal({commit, dispatch}, {reservations = [], source} = {}) {
      commit('showReassignModal', {reservations, source});
      dispatch('getReassignModalData', {uuids: Array.from(reservations).map(res => res.uuid).join(',')});
    },
    hideReassignModal({commit}) {
      commit('hideReassignModal');
    },
    async getReassignModalData({commit}, {uuids}) {
      commit('updateReassignModalLoading', true);
      let response = await LotsService.getReservations({
        "uuid": uuids,
        limit: 200
      }, 'inventory.receipt, lot.settlement');

      if (response.success) {
        commit('updateReassignModalItems', response.body.results)
      }
      commit('updateReassignModalLoading', false);
      return response;
    },
    async showBulkAdjustPriceModal({commit}, payload) {
      commit('showBulkAdjustPriceModal', payload);
    },
    hideBulkPriceAdjustModal({commit}) {
      commit('hideBulkPriceAdjustModal');
    },
    async showBatchSessionUpdateModal({commit}, payload) {
      commit('showBatchSessionUpdateModal', payload);
    },
    hideBatchSessionUpdateModal({commit}) {
      commit('hideBatchSessionUpdateModal');
    },
    async showBatchFinancialUpdateModal({commit}, payload) {
      commit('showBatchFinancialUpdateModal', payload);
    },
    hideBatchFinancialUpdateModal({commit}) {
      commit('hideBatchFinancialUpdateModal');
    },
    async bulkAdjustPrice({state}, payload) {
      let response = await LotsService.bulkAdjustPrice(payload.uuid, payload);
      if (response.success && state.reservationModal.source === SOURCE_LOTS_TABLE) {
        // commit('bulkAdjustPrice', response.body);
      }
      return response;
    },
    async showBatchCollectionUpdateModal({commit}, payload) {
      commit('showBatchCollectionUpdateModal', payload);
    },
    hideBatchCollectionUpdateModal({commit}) {
      commit('hideBatchCollectionUpdateModal');
    },
    async batchUpdateHideLot({dispatch}, payload) {
      let response = await LotsService.batchUpdateHideLot(payload)
      if (response.success) {
        dispatch('getTableData')
      }
      return response
    },
    async showAuctionResultsSyncModal({commit}, payload) {
      commit('showAuctionResultsSyncModal', payload);
    },
    hideAuctionResultsSyncModal({commit}) {
      commit('hideAuctionResultsSyncModal');
    },
    async batchUpdateAuctionLotImages({dispatch}, payload) {
      let response = await LotsService.batchUpdateAuctionLotImages(payload)
      if (response.success) {
        dispatch('getTableData')
      }
      return response
    },

    async showBatchLotUnsoldModal({commit}, payload) {
      commit('showBatchLotUnsoldModal', payload);
    },
    hideBatchLotUnsoldModal({commit}) {
      commit('hideBatchLotUnsoldModal');
    },
    showLotInfoModal({state}, {lot_uuid}) {
      state.lotInfoModal.show = true
      state.lotInfoModal.lot_uuid = lot_uuid
    },
    hideLotInfoModal({state}) {
      state.lotInfoModal.lot_uuid = null
      state.lotInfoModal.show = false
    },
  },
  mutations: {
    updateTableData: (state, payload) => state.tableData[state.tableSource] = {...state.tableData[state.tableSource], ...payload},
    updateTableLoading: (state, payload) => state.tableData[state.tableSource].loading = payload,
    showModal: (state, {object, source, sale}) => {
      state.modal.show = true;
      state.modal.object = _.cloneDeep(object);
      state.modal.sale = sale;
      state.modal.source = source;
      state.modal.receipt = null;
    },
    updateModalReceipt: (state, payload) => state.modal.receipt = payload,
    hideModal: state => state.modal.show = false,
    changeCurrentLotLoading: state => state.view.loading = !state.view.loading,
    updateViewLot: (state, lot) => state.view.currentLot = lot,
    updateLot: (state, lot) => {
      const index = state.tableData[state.tableSource].rows.findIndex(i => i.uuid === lot.uuid);
      if (index > -1) {
        state.tableData[state.tableSource].rows[index] = {...state.tableData[state.tableSource].rows[index], ...lot};
        state.tableData[state.tableSource].rows = [...state.tableData[state.tableSource].rows];
      }
    },
    updateSearchModel: (state, searchModel) => state.tableData[state.tableSource].searchModel = searchModel,
    showReservationModal: (state, {source, sale, disableFields = []}) => {
      state.reservationModal.show = true;
      state.reservationModal.sale = sale;
      state.reservationModal.source = source;
      state.reservationModal.disableFields = disableFields;
    },
    hideReservationModal: state => {
      state.reservationModal.show = false
      state.reservationModal.source = null
      state.reservationModal.object = null
      state.reservationModal.sale = null
      state.reservationModal.disableFields = []
    },
    showQrLotUpModal: (state, {sale, source}) => {
      state.qrLotUpModal.show = true;
      state.qrLotUpModal.source = source;
      state.qrLotUpModal.sale = sale;
    },
    hideQrLotUpModal: state => state.qrLotUpModal.show = false,

    showLotImagesNameModal: (state, {sale, source, mode, lot_uuids, lot_count, inventory_uuids, inventory_count}) => {
      state.lotExportImagesTemplateModal.show = true;
      state.lotExportImagesTemplateModal.source = source;
      state.lotExportImagesTemplateModal.sale = sale;
      state.lotExportImagesTemplateModal.mode = mode || 'all';
      state.lotExportImagesTemplateModal.lot_uuids = lot_uuids || null;
      state.lotExportImagesTemplateModal.lot_count = lot_count || 0;
      state.lotExportImagesTemplateModal.inventory_uuids = inventory_uuids || null;
      state.lotExportImagesTemplateModal.inventory_count = inventory_count || 0;
    },
    hideLotImagesName: state => {
      state.lotExportImagesTemplateModal.show = false;
      state.lotExportImagesTemplateModal.mode = 'all';
      state.lotExportImagesTemplateModal.lot_uuids = null;
      state.lotExportImagesTemplateModal.lot_count = 0;
      state.lotExportImagesTemplateModal.inventory_uuids = null;
      state.lotExportImagesTemplateModal.inventory_count = 0;
    },

    updateModalObject: (state, {object, source}) => {
      state.reservationModal.object = object;
      state.reservationModal.source = source;
    },
    showNegotiationModal: (state, {reservation, sale, source}) => {
      state.negotiationModal.show = true;
      state.negotiationModal.reservation = reservation;
      state.negotiationModal.sale = sale;
      state.negotiationModal.source = source;
    },
    hideNegotiationModal: state => {
      state.negotiationModal.show = false
      state.negotiationModal.reservation = null;
      state.negotiationModal.sale = null;
      state.negotiationModal.source = null;
    },
    showReserveItemsModal: (state) => {
      state.reserveItemsModal.show = true;
    },
    hideReserveItemsModal: state => state.reserveItemsModal.show = false,
    setActiveLot(state, activeLot) {
      state.auctioneerConsole.activeLot = activeLot
    },
    updateAuctioneerConsoleLoading(state, val) {
      state.auctioneerConsole.loading = val
    },
    updateAuctioneerConsoleSale(state, val) {
      state.auctioneerConsole.sale = val
    },
    updateToggleColumns: (state, selectedColumns) => {
      state.tableData[state.tableSource].toggleColumns.defaultFields = [...selectedColumns];
      let selectedFields = [];
      let notSelectedFields = [];
      selectedColumns.forEach(s => {
        selectedFields.push({
          ...state.tableData[state.tableSource].toggleColumns.fields.find(f => f.key === s),
          isVisible: true
        });
      });
      state.tableData[state.tableSource].toggleColumns.fields.forEach(f => {
        if (!selectedColumns.includes(f.key)) {
          notSelectedFields.push({...f, isVisible: false});
        }
      });
      state.tableData[state.tableSource].toggleColumns.fields = [...selectedFields, ...notSelectedFields];
    },
    showReassignModal: (state, {source}) => {
      state.reassignModal.show = true;
      state.reassignModal.source = source;
    },
    updateReassignModalItems: (state, reservations) => {
      state.reassignModal.reservations = reservations;
    },
    updateReassignModalLoading: (state, payload) => state.reassignModal.loading = payload,
    hideReassignModal: state => {
      state.reassignModal.show = false;
      state.reassignModal.reservations = [];
      state.reassignModal.source = null;
    },
    resetSearchModel: state => {
      state.tableData[state.tableSource].searchModel = new LotSearch()
    },
    showBulkAdjustPriceModal: (state, {reservations, source, increment_calculation_source}) => {
      state.bulkAdjustPriceModal.show = true;
      state.bulkAdjustPriceModal.reservations = reservations;
      state.bulkAdjustPriceModal.source = source;
      state.bulkAdjustPriceModal.increment_calculation_source = increment_calculation_source;
    },
    hideBulkPriceAdjustModal: (state) => {
      state.bulkAdjustPriceModal.show = false;
      state.bulkAdjustPriceModal.reservations = [];
      state.bulkAdjustPriceModal.source = null;
    },
    showBatchSessionUpdateModal: (state, {reservations, source, sale}) => {
      state.batchSessionUpdateModal.show = true;
      state.batchSessionUpdateModal.reservations = reservations;
      state.batchSessionUpdateModal.source = source;
      state.batchSessionUpdateModal.sale = sale;
    },
    hideBatchSessionUpdateModal: (state) => {
      state.batchSessionUpdateModal.show = false;
      state.batchSessionUpdateModal.reservations = [];
      state.batchSessionUpdateModal.source = null;
      state.batchSessionUpdateModal.sale = null;
      state.batchSessionUpdateModal.loading = false;
    },
    showBatchFinancialUpdateModal: (state, {reservations, source}) => {
      state.batchFinancialUpdateModal.show = true;
      state.batchFinancialUpdateModal.reservations = reservations;
      state.batchFinancialUpdateModal.source = source;
    },
    hideBatchFinancialUpdateModal: (state) => {
      state.batchFinancialUpdateModal.show = false;
      state.batchFinancialUpdateModal.reservations = [];
      state.batchFinancialUpdateModal.source = null;
      state.batchSessionUpdateModal.loading = false;
    },
    showBatchCollectionUpdateModal: (state, {reservations, source, sale}) => {
      state.batchCollectionUpdateModal.show = true;
      state.batchCollectionUpdateModal.reservations = reservations;
      state.batchCollectionUpdateModal.source = source;
      state.batchCollectionUpdateModal.sale = sale;
    },
    hideBatchCollectionUpdateModal: (state) => {
      state.batchCollectionUpdateModal.show = false;
      state.batchCollectionUpdateModal.reservations = [];
      state.batchCollectionUpdateModal.source = null;
      state.batchCollectionUpdateModal.sale = null;
      state.batchCollectionUpdateModal.loading = false;
    },
    async showBatchLotUnsoldModal(state, payload) {
      state.unsoldModal.isLoading = true;
      state.unsoldModal.show = true;
      state.unsoldModal.selectedItems = payload;
      state.unsoldModal.isLoading = false;
    },
    hideBatchLotUnsoldModal(state) {
      state.unsoldModal.show = false
      state.unsoldModal.selectedItems = []
      state.unsoldModal.isLoading = false
      state.unsoldModal.error = null
    },
    showAuctionResultsSyncModal: (state, {source, sale}) => {
      state.auctionResultsSyncModal.show = true;
      state.auctionResultsSyncModal.source = source;
      state.auctionResultsSyncModal.sale = sale;
    },
    hideAuctionResultsSyncModal: (state) => {
      state.auctionResultsSyncModal.show = false;
      state.auctionResultsSyncModal.source = null;
      state.auctionResultsSyncModal.sale = null;
      state.auctionResultsSyncModal.loading = false;
    },
  }
}
